module.exports = __webpack_public_path__ + "img/headerZ.9946b53a.png";